import { Component, Inject, Optional } from '@angular/core';
import { CellRendererBase, CellRendererData, CELL_RENDERER_TOKEN } from '../cell-renderer';
import * as moment from 'moment';
import { MessageTransportService } from '@nx-fe/services';
import { XsI18nPipe } from '@nx-fe/pipes';
import { IconCellData, StringCellData } from '../renderer.models';

// TODO: Check if we still need to support the DateDataStructure
// This is was defined in the DID version of the formatter, but might not be used. - Werner
export interface DateDataStructure {
  dateFormat: string;
  value: string | Date;
}

type DateData = string | Date | DateDataStructure | StringCellData; // Overloaded to cater for old DID formatter behaviour

function isDateStructure(date: DateData): date is DateDataStructure {
  return (date as DateDataStructure).dateFormat !== undefined;
}

function isStringCellData(date: DateData): date is StringCellData {
  return (date as StringCellData).csvValue !== undefined;
}

@Component({
  selector: 'ins-date-cell-renderer',
  templateUrl: './date-cell-renderer.component.html',
  styleUrls: ['./date-cell-renderer.component.scss'],
})
export class DateCellRendererComponent extends CellRendererBase {
  dataToRender = '';
  icons: IconCellData[];
  showTooltip: boolean = false;

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    params: CellRendererData<object | boolean | string | number>,
    protected _eventTransportService: MessageTransportService,
    private xsI18nPipe: XsI18nPipe
  ) {
    super(params, _eventTransportService);
  }

  static getDataToRender(value: DateData, paramDateFormat: string, xsI18nPipe: XsI18nPipe): string {
    if (!!value) {
      if (isStringCellData(value)) {
        return value.value;
      }
      let dateFormat: string = paramDateFormat ?? 'YYYY-MM-DD';
      if (isDateStructure(value)) {
        // this is legacy from DID - might no longer be used
        dateFormat = value.dateFormat;
        value = value.value;
      }

      if (!value) {
        return xsI18nPipe.transform('constant_no_data_label');
      }

      const date = moment(value);
      if (date.isValid()) {
        return date.format(dateFormat);
      } else {
        return xsI18nPipe.transform('constant_invalid_date_label');
      }
    }
    return xsI18nPipe.transform('constant_no_data_label');
  }

  init(cellData: CellRendererData<DateData>) {
    try {
      this.dataToRender = DateCellRendererComponent.getDataToRender(
        cellData.data,
        cellData.params?.format,
        this.xsI18nPipe
      );
      this.showTooltip = !!cellData.params?.showTooltip;

      if (cellData.params?.icons) {
        this.icons = cellData.params.icons;
      }
    } catch {
      this.dataToRender = cellData.data['value'];
    }
  }
}
